import SortableList from "../../Common/Components/Lists/SortableList";
import { Col } from "reactstrap";
import { CustomButton } from "../../Common/Components/Button/CustomButton";
import { useTranslation } from "react-i18next";
import { CheckUserRole } from "../../AppSystem/Helpers/CheckUserRole";
import ResponseSwedbankReport from "../Models/Response/ResponseSwedbankReport";
import { useNavigate } from "react-router-dom";
import { PAY_PATHS } from "../../config";
import { useHeader } from "../../Auth/Components/Nav/HeaderContext";
import { useEffect } from "react";

export function AdminSwedBankReport() {
    const isSuperAdmin = CheckUserRole("SuperAdmin");
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { setPageTitle, setPageTitleKey, setOnBack } = useHeader();

    useEffect(() => {
        setPageTitle(t('sidebar.swedbankReport'));
        setPageTitleKey('sidebar.swedbankReport');
        setOnBack(null);
        return () => { setPageTitle(''); setPageTitleKey(''); setOnBack(null); };
    }, [t]);

    const renderActionColumn = (item) => {
        return (
            <>
                <CustomButton icon="bx bx-show py-1" iconColor="#157553" hoverIconColor='white' hoverButtonColor='#A3C2B8' iconSize={4} buttonColor="#cde0da" tooltipText={t('button.info')} customClasses="rounded border-0" buttonBorder={false} onClick={() => { navigate(`${PAY_PATHS.SWEDBANKPAY_REPORT_INFO}?id=${item.id}`) }}  />
            </>
        );
    };

    const columns = ["visualId", 'reportingDate','accountingNumber','amount'];

    if (isSuperAdmin === true) {
        columns.unshift('id');
    }

    const listOptions = {
        "model": ResponseSwedbankReport,
        'columns': columns,
        "actions": {
            "actionColumn" : renderActionColumn,
        },
        "exportIsAvailable": true,
        "filterTestIsAvailable": true,
        "urlGetListItemsToExport": "/swedbank/search/admin/filter/report",
        "nameFile": t('modelLabel.user'),
        "ignoreFields" : columns,
        "urlGetSearch" : "/swedbank/search/admin/filter/report",
        "modelType" : "AdminSwedbankReport",
        "viewName": "AdminSwedbankReportList"
    };

    return(
        <>
            <Col lg="12" className='card card-backend p-4 mb-5'>
                <h2 className="pb-2 rokkitt-font">{t('sidebar.swedbankReport')}</h2>
                <SortableList
                    listOptions={listOptions}
                />
            </Col>
        </>);

}